import type { OutputFormatId } from './output-format';
import { presetFromRecipe, type PresetSettings } from './preset';
import { createDefaultRecipe, type EditRecipe } from './recipe';

/**
 * Converting is saving a video as it is, in another format: nothing is cut,
 * reframed or scanned, and the sound keeps its own level (a converter that
 * quietly made it louder would surprise). Like every export, it is written
 * from scratch on the device, so no original metadata comes along, and places
 * the person marked as private stay hidden.
 */
export const asConversion = (recipe: EditRecipe, output: OutputFormatId): EditRecipe => ({
  ...recipe,
  audio: { ...recipe.audio, normalize: false },
  output,
});

/** The same conversion as batch settings: every video in a list saved as it is. */
export const CONVERSION_SETTINGS: PresetSettings = presetFromRecipe(asConversion(createDefaultRecipe(), 'mp4'), {
  scan: [],
  precision: 'fast',
  captionLanguage: 'auto',
  captionQuality: 'accurate',
  hasCaptions: false,
  scanned: false,
});
